<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="技师ID">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入技师ID"></el-input>
        </el-form-item>
        <el-form-item label="技师名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入技师名称"></el-input>
        </el-form-item> -->
        <el-form-item label="技师号码">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入技师号码"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所在城市">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入所在城市"></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="所属商户">
          <el-select size="small" v-model="searchForm.shopSupplierId" placeholder="所属商户">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.shopSupplierId"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="waiter_user_id" align="center" label="技师ID"></el-table-column>
          <el-table-column prop="nickName" align="center" label="技师昵称"></el-table-column>
          <el-table-column prop="username" align="center" label="技师名称"></el-table-column>
          <el-table-column prop="mobile" align="center" label="技师号码"></el-table-column>
          <el-table-column prop="productName" align="center" label="技师头像">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.avatarUrl" alt="" /></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="serviceTime" align="center" label="服务时长">
            <template slot-scope="scope" v-if="scope.row.serviceTime">
              <span v-if="scope.row.serviceTime < 100" style="color: orange">{{ scope.row.serviceTime }}分钟</span>
              <span v-else-if="500 <= scope.row.serviceTime && scope.row.serviceTime < 1000" style="color: #0089ff">{{ scope.row.serviceTime }}分钟</span>
              <span v-else-if="scope.row.serviceTime >1000" style="color: red">{{ scope.row.serviceTime }}分钟</span>
              <span v-else style="color: red">{{ scope.row.serviceTime }}分钟</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="130">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="info" size="small" v-auth="'/product/product/edit'">查看</el-button>
              <!-- <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">审核</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>
    <Onlinedetail v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Onlinedetail>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Technician from "@/api/technician.js";
import Onlinedetail from "./onlinedetail";
export default {
  components: { Onlinedetail },
  data() {
    return {
      /*切换菜单*/
      activeName: "",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        mobile: "",
        createTime: ""
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryModel: {
        waiter_user_id: ""
      },

      serviceList: [],
      supplierList: [],
      /*商品统计*/
      product_count: {},
      open_edit: false
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    onExport: function() {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      Technician.timewaiterList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*打开编辑*/
    editClick(row) {
      this.categoryModel.waiter_user_id = row.waiter_user_id;
      this.open_edit = true;
      // this.$router.push({
      //   path: "/technician/online/onlinedetail",
      //   query: {
      //     waiter_user_id: row.waiter_user_id,
      //     scene: "edit"
      //   }
      // });
    },
    /*打开编辑*/
    // editClick(row) {

    //   this.categoryModel.model = item;
    //   this.open_edit = true;
    // },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          Technician.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switchs .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switchs .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switchs .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switchs .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switchs .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switchs .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switchs.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/technician/online/index.vue